import { Navigate, Outlet, useLocation } from 'react-router';
import { Button } from '../../components/Button';
import { Card } from '../../components/Card';
import { SkyPage } from '../../components/SkyPage';
import { da } from '../../i18n/da';
import { useAuth } from './auth-context';
import styles from './AuthPage.module.css';

/** Layout route: shows its pages only to logged-in players and sends everyone else to login. */
export function RequireAuth() {
  const { state, refresh } = useAuth();
  const location = useLocation();

  if (state.status === 'loading') {
    return <SkyPage>{null}</SkyPage>;
  }
  if (state.status === 'offline') {
    return (
      <SkyPage>
        <Card className={styles.card} role="alert">
          <p className={styles.intro}>{da.auth.offline}</p>
          <Button onClick={refresh}>{da.auth.tryAgain}</Button>
        </Card>
      </SkyPage>
    );
  }
  if (!state.user) {
    const next = `${location.pathname}${location.search}`;
    return <Navigate to={`/login?next=${encodeURIComponent(next)}`} replace />;
  }
  return <Outlet />;
}
